import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import biLogger from '@wix/da-bi/pkg/BiLogger.logger';
import { BiData } from '@wix/da-bi/pkg/events';
import { getPublicSession } from '../../../publicSession/selectors';
import { getBiEventComponentByType } from '../../../DeviationPage/redux/helpers';
import { getDeviationResourceType, getDeviationType } from '../../_helpers';
/** Returns a callback that fires a ZoomModeBiEvent */ export function useZoomBiLogger(deviation) {
    const publicSession = useSelector(getPublicSession, ()=>true);
    return useCallback((isBeingZoomed)=>{
        const event = BiData({
            evid: 303,
            view: !deviation.isPublished ? 'stash' : 'submission',
            component: getBiEventComponentByType(getDeviationType(deviation)),
            typeid: getDeviationResourceType(deviation),
            deviationid: deviation.deviationId,
            viewmode: isBeingZoomed ? 'zoom' : 'regular'
        });
        biLogger.log(publicSession, event);
    }, [
        deviation,
        publicSession
    ]);
}

//# sourceMappingURL=useZoomBiLogger.js.map